import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';

export default function DGTH_item_model_movement({ entity, searchObj }) {

    const [movementStats, setMovementStats] = useState(null);
    const [movementStatsLoading, setMovementStatsLoading] = useState(false);

    useEffect(() => {
        async function fetchMovementStats() {
            if (!searchObj || !searchObj.query || searchObj.query.trim() === '') {
                setMovementStats(null);
                return;
            }

            try {
                setMovementStatsLoading(true);
                const query = searchObj.query || '';
                const fields = searchObj.fields || [];
                const constraints = searchObj.constraints || [];

                const response = await DataManager.searchItemsSimple(
                    'item_model_movement',
                    1,
                    1000,
                    { field: 'id', order: 'desc' },
                    query,
                    fields,
                    constraints
                );

                if (response.success === 1 && Array.isArray(response.body)) {
                    let totalLoads = 0;
                    let totalUnloads = 0;
                    let sumLoads = 0;
                    let sumUnloads = 0;

                    response.body.forEach(row => {
                        const qty = parseFloat(row.quantity) || 0;
                        if (row.type?.value === 'LOAD') {
                            totalLoads += 1;
                            sumLoads += qty;
                        } else if (row.type?.value === 'UNLOAD') {
                            totalUnloads += 1;
                            sumUnloads += qty;
                        }
                    });

                    const totalMovements = response.body.length;
                    const saldo = sumLoads - sumUnloads;

                    setMovementStats({
                        totalMovements,
                        totalLoads,
                        sumLoads,
                        sumUnloads,
                        totalUnloads,
                        saldo
                    });
                } else {
                    setMovementStats(null);
                }
            } catch (e) {
                console.error(e);
                setMovementStats(null);
            } finally {
                setMovementStatsLoading(false);
            }
        }

        fetchMovementStats();
    }, [entity, searchObj]);

    if (!movementStats || !searchObj || !searchObj.query || searchObj.query.trim() === '') {
        return null;
    }

    return (
        <Row className='my-3'>
            <Col xs={12} md={3} className='mb-2'>
                <Card>
                    <Card.Body>
                        <Card.Title className='small'>Totale movimentazioni</Card.Title>
                        <Card.Text className='fs-5'>
                            {movementStatsLoading ? <Spinner animation="border" size="sm" /> : movementStats.totalMovements}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} md={3} className='mb-2'>
                <Card>
                    <Card.Body>
                        <Card.Title className='small'>Totale carichi</Card.Title>
                        <Card.Text className='fs-5'>
                            {movementStatsLoading ? <Spinner animation="border" size="sm" /> : movementStats.sumLoads}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} md={3} className='mb-2'>
                <Card>
                    <Card.Body>
                        <Card.Title className='small'>Totale scarichi</Card.Title>
                        <Card.Text className='fs-5'>
                            {movementStatsLoading ? <Spinner animation="border" size="sm" /> : movementStats.sumUnloads}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} md={3} className='mb-2'>
                <Card>
                    <Card.Body>
                        <Card.Title className='small'>Saldo</Card.Title>
                        <Card.Text className='fs-5'>
                            {movementStatsLoading ? <Spinner animation="border" size="sm" /> : movementStats.saldo}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}
